export const isLocationRegister = location => location.pathname === '/register';
